import { VueModule } from '@Foundation/utilities';
import Routine from './code/Scripts/components/routine';

export default VueModule({
  components: {
    Routine
  }
});
